module.exports = __webpack_public_path__ + "media/images/emoticons/dollar-131d7bdbc6a4bc447791ea4b5d0f2fcf.gif";